module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-2-8a8f286d49396e952ced6a3d284a8894.png";